import type { InferRpcDefinition } from "@redotech/rpc/definition";
import { checkMetaDeletionStatus } from "./schema/check-meta-deletion-status";
import { generateCopilotResponse } from "./schema/generate-copilot-response";
import { getBaseSupportPredictedPriceInfo } from "./schema/get-base-support-predicted-price-info";
import { getShopperAiDashboardMetrics } from "./schema/get-concierge-dashboard-metrics";
import { getShopperAiSettingsOptimization } from "./schema/get-shopper-ai-settings-optimization";
import { markConversationsSpam } from "./schema/mark-conversations-spam";
import { supportAnalytics } from "./schema/support-analytics";
import { updateGmailIntegrationName } from "./schema/update-gmail-integration-name";
import { upsertShopperAiSettingsOptimization } from "./schema/upsert-shopper-ai-settings-optimization";

export const rpcDefinition = {
  checkMetaDeletionStatus,
  generateCopilotResponse,
  getBaseSupportPredictedPriceInfo,
  getShopperAiDashboardMetrics,
  getShopperAiSettingsOptimization,
  markConversationsSpam,
  supportAnalytics,
  updateGmailIntegrationName,
  upsertShopperAiSettingsOptimization,
};

export type RedoSupportRpcDefinition = InferRpcDefinition<typeof rpcDefinition>;
